// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalQuestion_header__EKIT3","headerIcon":"ModalQuestion_headerIcon__WacOF","description":"ModalQuestion_description___l6Ye"};